import type { ContactListScope } from '@/hooks/contacts/contactQueryKeys';

/** Query string the Contacts list already uses, so bulk actions match the same rows. */
export function contactBulkRequestPath(path: string, scope?: ContactListScope): string {
  if (!scope) return path;
  const params = new URLSearchParams();
  if (scope.search) params.set('search', scope.search);
  if (scope.groupId) params.set('groupId', scope.groupId);
  if (scope.groupIds) params.set('groupIds', scope.groupIds);
  if (scope.filters) params.set('filters', scope.filters);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

/**
 * `scope` asks the server to resolve every matching contact. Loaded ids stay off that body.
 */
export function contactBulkRequestBody(
  fields: Record<string, unknown>,
  scope?: ContactListScope
): Record<string, unknown> {
  if (!scope) return fields;
  const { contactIds: _contactIds, entityIds: _entityIds, ...rest } = fields;
  return { ...rest, scope: true };
}
